export default __webpack_public_path__ + "static/Logo_Joint_Commission-06990e189c8389e944b4e162cd1263f9.png";